enum BillingsCargoOrderListingItemBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPENED = "REOPENED",
  REOPEN_REQUEST_SENT = "REOPEN_REQUEST",
}

export default BillingsCargoOrderListingItemBillingStatus;
